import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, DefaultComponentProps } from "@albo-ui/core";

export type ConfirmDialogDialogProps = {
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    title: string;
    message: string;
    item: string;
} & DefaultComponentProps;

export const ItemConfirmDialog = ({ onConfirm, onClose, open, title, message, item }: ConfirmDialogDialogProps) => {
    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant="h2">{title}</Typography>
            </DialogTitle>
            
            <DialogContent>
                <FlexGrid>
                    <Typography variant="paragraph">{message}</Typography>
                </FlexGrid>
                <FlexGrid style={{marginTop: 20 }}>
                    <Typography variant="paragraph" bold>{item}</Typography>
                    <hr/>
                </FlexGrid>	
            </DialogContent>

            <DialogActions>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: "20px", display: "flex" }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onConfirm} size="normal">
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
